import imgHeadline from "../assets/arteHeadline.png";
import InfoCard from "./InfoCard";

import cartIcon from "../assets/cart.png";
import shipIcon from "../assets/ship.png";
import totalIcon from "../assets/total.png";
import useOrdersStore from "../store/ordersStore";
import { useEffect, useState } from "react";
import api from "../services/api";
import { useAuth } from "../contexts/AuthContext";

const CardUser = () => {
  const { getAllOrders, orders, loading, error } = useOrdersStore();
  const [pedidos, setPedidos] = useState([]);
  const [user, setUser] = useState({});
  const totalAmountLeft = orders.reduce((acumulador, order) => {
    return acumulador + order.amount_left;
  }, 0);

  const totalAmountLeftFormated = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "USD",
  }).format(totalAmountLeft);

  useEffect(() => {
    getAllOrders();
  }, [getAllOrders]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await api.get("/order-load/last-order");
        setPedidos(response.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  return (
    <div className="bg-veryLightGray rounded-md grid grid-cols-12 flex-1  text-boldGray opacity-70 md:col-span-9 ">
      <div className="md:ml-4 lg:ml-6 xl:ml-6 md:py-2 py-4 col-span-9 md:col-span-7 lg:col-span-9 xl:col-span-9">
        <div className=" lg:mt-4 ">
          <p className="font-bold 2xl:text-3xl xl:text-2xl lg:text-xl md:text-lg ">
            Bom dia, {user.name}
          </p>
          <p className="lg:mt-2 md:text-sm">
            Veja os principais resumos de hoje.
          </p>
        </div>
        <div className="lg:flex lg:justify-between  xl:mt-10 md:mt-1 lg:mt-3">
          <InfoCard>
            <div className="flex justify-between items-center">
              <div className="flex items-center md:max-w-[27px] md:max-h-[27px] lg:max-w-[32px] lg:max-h-[32px]">
                <img className="sm:w-3/4 xl:w-full" src={cartIcon} alt="" />
              </div>

              <div className="flex items-center xl:ml-2">
                <p className="leading-none md:text-xs">
                  <span className="font-bold opacity-90 xl:text-lg">
                    Pedidos
                  </span>
                  <br />
                  <span className="xl:text-sm"> Em andamento</span>
                </p>
              </div>
              <span className="font-bold text-[#FF9533] text-3xl md:text-2xl xl:ml-2">
                {orders.length}
              </span>
            </div>
          </InfoCard>

          <InfoCard>
            <div className="flex justify-between col-span-3">
              <div className="flex items-center md:max-w-[27px] md:max-h-[27px] lg:max-w-[38px] lg:max-h-[38px]">
                <img className="sm:w-3/4 xl:w-full" src={shipIcon} alt="" />
              </div>

              <div className="flex items-center xl:ml-2">
                <p className="leading-none md:text-xs">
                  <span className="font-bold opacity-90 xl:text-lg">
                    Cargas
                  </span>
                  <br />
                  <span className="xl:text-sm">Em andamento</span>
                </p>
              </div>
              <span className="font-bold text-[#FF9533] text-3xl md:text-2xl xl:ml-2">
                {pedidos.length}
              </span>
            </div>
          </InfoCard>

          <InfoCard>
            <div className="flex col-span-3 items-center">
              <div className="flex items-center md:max-w-[27px] md:max-h-[27px] lg:max-w-[38px] lg:max-h-[38px]">
                <img className="sm:w-3/4 xl:w-full" src={totalIcon} alt="" />
              </div>

              <div className="flex items-center md:ml-6 xl:ml-2 ml-2">
                <p className="leading-none md:text-xs">
                  <span className="font-bold opacity-90 xl:text-lg">
                    {totalAmountLeftFormated}
                  </span>
                  <br />
                  <span className="xl:text-sm">A pagar</span>
                </p>
              </div>
            </div>
          </InfoCard>
        </div>
      </div>
      <div className="flex justify-end m-0 xl:ml-8 relative bottom-[10px] left-[16px] col-span-3 md:col-span-5 lg:col-span-3 xl:col-span-3">
        <img className="" src={imgHeadline} alt="" />
      </div>
    </div>
  );
};

export default CardUser;
